import { sortByTimestamp } from '@iotv/datamodel-core';
import { AppValueTypes } from '@iotv/iotv-v3-types';
export const metricItemsToVOBs = ({ psuedoParentVob, pseudoTypeId, stateSnapshots }) => stateSnapshots
    .map((stateSnapshot, i) => {
    const { state: { ...atts }, timestamp, } = stateSnapshot;
    const id = `${psuedoParentVob?.id ?? 'unknownId'}_${i}_${timestamp}`;
    const pk = psuedoParentVob?.sk ?? 'unknownParentSk';
    const sk = `${psuedoParentVob?.type}:${id}`;
    const type = pseudoTypeId;
    const intlnz = new Intl.DateTimeFormat('en-NZ', {
        year: 'numeric',
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: 'NZ',
        hour: 'numeric',
        minute: 'numeric',
    });
    const localTimeStr = timestamp ? intlnz.format(new Date(timestamp)) : 'unknown';
    return {
        type,
        sk,
        pk,
        id,
        ...atts,
        timestamp,
        localTimeStr,
    };
})
    .sort(sortByTimestamp);
export const filterKeysToViewDefinition = (filterMetricKeys = []) => {
    const viewDefinition = {};
    filterMetricKeys.unshift('timestamp');
    filterMetricKeys.forEach((key) => {
        const viewDefinitionKey = {
            key,
            editable: false,
            label: key.toUpperCase(),
            precision: undefined,
            stateFn: undefined,
            type: AppValueTypes.NUMBER,
            unit: undefined,
            validationRx: undefined,
            enumKV: undefined,
            failsValidationText: undefined,
        };
        viewDefinition[key] = viewDefinitionKey;
    });
    return viewDefinition;
};
export const filterKeysByTypeToViewDefinition = (filterMetricKeys, arrayMap) => {
    const keys = arrayMap ? filterMetricKeys?.filter((key) => arrayMap[key] && arrayMap[key].every((item) => item === null || typeof item !== 'object')) : [];
    return filterKeysToViewDefinition(keys);
};
export const ducktype = (key, value) => {
    let type = AppValueTypes.STRING;
    if (!isNaN(parseFloat(value))) {
        type = AppValueTypes.NUMBER;
    }
    else if ([false, true].includes(value)) {
        type = AppValueTypes.BOOLEAN; // would need to change value
    }
    if (key === 'timestamp') {
        type = AppValueTypes.TIMESTAMP_MS; // needs to be string fmt used in date
    }
    return type;
};
